<template>
    <table class="table rate-table">
        <thead>
        <tr>
            <th>Additional Information</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>{{ reservation.additional_info || '-' }}</td>
        </tr>
        </tbody>
    </table>
</template>

<script>

export default {
    name    : "AdditionalInformation",
    computed: {
        reservation() {
            return this.$store.state.model.reservation;
        },
    }
}
</script>

<style scoped>

</style>
